import { Pipe, PipeTransform } from '@angular/core';
import {EThreadScope, EThreadType, ThreadModel} from '@atlas-workspace/shared/models';

@Pipe({
  name: 'tagsThread',
  standalone: true,
})
export class TagsThreadPipe implements PipeTransform {
  transform(thread: ThreadModel, scope?: EThreadScope, scopes?: typeof EThreadScope): string {
    if (scope && scope === scopes?.Unit) return ''
    if (thread.changeRequestId) return 'Title.Change_request';
    if (!thread.changeRequestId && thread.reclamationId
      || (!thread.reclamationId && (
        thread.threadType === EThreadType.InternalNotes
        || thread.threadType === EThreadType.OnlyAdmins
        || thread.threadType === EThreadType.Messageable
      ))) return 'Shared.Entity.Reclamation';
    return '';
  }
}
